import {
  Module,
  VuexModule,
  Mutation,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  ANNOUNCEMENT_CREATE,
  ANNOUNCEMENT_LIST,
  ANNOUNCEMENT_DELETE,
  ANNOUNCEMENT_UPDATE,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'announcement' })
export default class Announcement extends VuexModule {
  announcementList: any = [];

  @Mutation
  mutateAnnouncement(announcement) {
    this.announcementList = announcement;
  }

  @Action({ commit: 'mutateAnnouncement' })
  FetchAnnouncement(params: any = { type: 'total' }) {
    return Vue.axios({
      url: BASE_URL + ANNOUNCEMENT_LIST,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action
  CreateAnnouncement(params) {
    return Vue.axios({
      url: BASE_URL + ANNOUNCEMENT_CREATE,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data.status)
      .catch((err) => err);
  }

  @Action
  DeleteAnnouncement(params) {
    return Vue.axios({
      url: BASE_URL + ANNOUNCEMENT_DELETE,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data.status)
      .catch((err) => err);
  }

  @Action
  UpdateAnnouncement(params) {
    return Vue.axios({
      url: BASE_URL + ANNOUNCEMENT_UPDATE,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data.status)
      .catch((err) => err);
  }
}
